import { colorConstants } from 'config/colorConstants';

type ProfitPoolTier = {
    tierName: string;
    tierReference: string;
};

type ProfitPoolTierColorConfig = {
    marginPercentChartColors?: string[];
    tiersColorMapPPOverview?: Record<string, string>;
    tiersColorMap?: Record<string, string>;
};

const DEFAULT_PROFIT_POOL_TIER_COLORS = [
    colorConstants.violetAlt,
    colorConstants.limeGreen,
    colorConstants.lightOrangeAlt,
    colorConstants.violetAlt3,
    colorConstants.lightBlueAlt,
    colorConstants.greenALt1,
];

export function buildProfitPoolTierNameColorMap(
    profitPoolTierList: ProfitPoolTier[] = [],
    config: ProfitPoolTierColorConfig = {},
): Record<string, string> {
    const { marginPercentChartColors, tiersColorMapPPOverview } = config;

    return profitPoolTierList.reduce<Record<string, string>>((acc, tier, index) => {
        const colorFromPalette = marginPercentChartColors?.[index];
        const colorFromTierRef = tiersColorMapPPOverview?.[tier.tierReference];
        const colorFromDefault = DEFAULT_PROFIT_POOL_TIER_COLORS[index % DEFAULT_PROFIT_POOL_TIER_COLORS.length];

        acc[tier.tierName] = colorFromPalette ?? colorFromTierRef ?? colorFromDefault;
        return acc;
    }, {});
}

export function buildProfitPoolEvolutionTierColorMap(
    profitPoolTierList: ProfitPoolTier[] = [],
    config: ProfitPoolTierColorConfig = {},
): Record<string, string> {
    const { tiersColorMap, marginPercentChartColors } = config;

    return profitPoolTierList.reduce<Record<string, string>>((acc, tier, index) => {
        const colorFromPalette = marginPercentChartColors?.[index];
        const currentYearColor = tiersColorMap?.[tier.tierReference];
        const yearAgoColor = tiersColorMap?.[`${tier.tierReference}(YA)`];
        const colorFromDefault = DEFAULT_PROFIT_POOL_TIER_COLORS[index % DEFAULT_PROFIT_POOL_TIER_COLORS.length];

        acc[tier.tierName] = currentYearColor ?? colorFromPalette ?? colorFromDefault;
        acc[`${tier.tierName} (YA)`] = yearAgoColor ?? currentYearColor ?? colorFromPalette ?? colorFromDefault;
        return acc;
    }, {});
}
